import {
  DropdownProps,
  Grid,
  Icon,
  Input,
  Loader,
  Popup,
  Select,
} from "semantic-ui-react";
import usePoolOptions from "./hooks/usePoolOptions";
import { useEffect } from "react";
import AddressingType from "../../../../networks/create/subnets/bits/AddressingType";

type SubnetPoolProps = {
  region: string;
  onChange: (event: React.FormEvent<HTMLElement>, data: DropdownProps) => void;
  selectedSubnetPoolId: string;
  addressingType: string;
};

const Title = () => {
  return (
    <Grid.Column
      textAlign="left"
      width={8}
      className="flex vcenter margin-top-30"
    >
      <h5>
        Subnet Pool
        <Popup
          trigger={
            <Icon
              name="warning circle"
              color="grey"
              size="small"
              className="margin-left-10"
            />
          }
        >
          Choose Subnet Pool
        </Popup>
      </h5>
    </Grid.Column>
  );
};

const SubnetPool = ({
  region,
  onChange,
  selectedSubnetPoolId,
  addressingType,
}: SubnetPoolProps) => {
  const { loading, error, poolsOptions, poolsList } = usePoolOptions(region);

  useEffect(() => {
    if (poolsOptions.length === 1) {
      onChange(
        {} as React.FormEvent<HTMLElement>,
        {
          name: "selectedSubnetPoolId",
          value: poolsOptions[0].value,
        } as DropdownProps,
      );
    }
  }, [onChange, poolsOptions]);

  const pool = poolsList.find((pool) => pool.id === selectedSubnetPoolId);

  if (loading) {
    return (
      <>
        <Title />
        <Grid.Column width={8} className="flex vcenter padding-top-30">
          <div className="loader-wrapper">
            <Loader size="mini" active className="one-liner ">
              Fetching Subnet Pools list...
            </Loader>
          </div>
        </Grid.Column>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Title />
        <Grid.Column width={8} className="flex vcenter margin-top-30">
          <Input value={error} disabled />
        </Grid.Column>
      </>
    );
  }

  return (
    <>
      <Title />
      <Grid.Column width={8} className="flex vcenter margin-top-30">
        <Select
          icon="chevron circle down"
          className="select-box full"
          placeholder="Choose Subnet Pool"
          value={selectedSubnetPoolId}
          options={poolsOptions}
          name="selectedSubnetPoolId"
          onChange={onChange}
        />
      </Grid.Column>
      {pool && selectedSubnetPoolId && (
        <AddressingType
          onChange={onChange}
          pool={pool}
          addressingType={addressingType}
        />
      )}
    </>
  );
};

export default SubnetPool;
